export default "__VITE_ASSET__R$OULVhK__"